import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface OrigenQuejaPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface OrigenQueja {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface OrigenQuejaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class OrigenQuejasService {
  private readonly apiUrl = `${environment.apiUrl}/api/origen_quejas`;

  constructor(private http: HttpClient) {}

  // Listar todos los orígenes de quejas
  getAll(): Observable<OrigenQueja[]> {
    return this.http.get<OrigenQueja[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<OrigenQueja> {
    return this.http.get<OrigenQueja>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo origen de queja
  create(payload: OrigenQuejaPayload): Observable<OrigenQuejaResponse> {
    return this.http.post<OrigenQuejaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar origen de queja
  update(id: number, payload: Partial<OrigenQuejaPayload>): Observable<OrigenQuejaResponse> {
    return this.http.put<OrigenQuejaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar origen de queja (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar origen de queja
  inactivar(id: number): Observable<OrigenQuejaResponse> {
    return this.http.put<OrigenQuejaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar origen de queja
  activar(id: number): Observable<OrigenQuejaResponse> {
    return this.http.put<OrigenQuejaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}